($.fn.dataTable.ext as any).feature.push({
	cFeature: 'J',
	fnInit(oSettings) {
		const table = $(oSettings.nTable).DataTable();
		const tableId = oSettings.sTableId;
		const features = oSettings.aanFeatures;

		oSettings.reverseOrder = false;

		const liNode = $('<li/>', {
			class: 'paginate_button page-item',
			id: tableId + '_reverse-order',
		});

		const aNode = $('<a>', {
			class: 'page-link',
			'aria-controls': tableId,
			'data-dt-idx': 3,
			tabindex: 0,
			href: '#',
			role: 'button',
		}).append('Reverse Order');

		const buttonDiv = $('<div/>', {
			id: !features.f ? tableId + '_reverse-order' : null,
			class: 'dataTables_reverse-order dataTables_paginate',
		}).append(
			$('<ul/>', {
				class: 'pagination',
			}).append(liNode.append(aNode)),
		);

		const clickHandler = (e) => {
			e.preventDefault();
			oSettings.reverseOrder = !oSettings.reverseOrder;
			if (oSettings.reverseOrder) {
				liNode.addClass('active');
			} else {
				liNode.removeClass('active');
			}
			table.draw();
		};
		const internal = <any>$.fn.dataTable.ext.internal;
		internal._fnBindAction(aNode, {}, clickHandler);

		return buttonDiv[0];
	},
});
